import {FC, useState} from 'react';

import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import UsersTable from './UsersTable';
import UserGroupsTable from './UserGroupsTable';
import UserAccountControl from './UserAccountControl';
import {Tab, Tabs} from '@mui/material';
import TabPanel from '../../ui/tab-panel/TabPanel';
import UserGroupControl from './UserGroupControl';

const Users: FC = () => {
  const [value, setvalue] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setvalue(newValue);
  };

  return (
    <>
      <Box sx={{width: '100%'}}>
        <Box sx={{width: '96%', margin: '0 auto', mt: 2, mb: 4}}>
          <Paper sx={{width: '400px', borderRadius: 0, mb: 2}}>
            <Tabs variant="fullWidth" value={value} onChange={handleChange}>
              <Tab label="Пользователи" />
              {/* 
                TODO: Доработать функционал с бригадами, когда станет нужен
                <Tab label="Группы" />
              */}
            </Tabs>
          </Paper>
          <Paper>
            <TabPanel sx={{minHeight: 'auto'}} value={value} index={0}>
              <UsersTable />
            </TabPanel>
            {/* 
              TODO: Доработать функционал с бригадами, когда станет нужен
              <TabPanel sx={{minHeight: 'auto'}} value={value} index={1}>
                <UserGroupsTable />
              </TabPanel> 
            */}
          </Paper>
        </Box>
      </Box>
      <UserAccountControl />
      <UserGroupControl />
    </>
  );
};

export default Users;
